// Copyright (c) Docugami, Inc. All rights reserved.

import { BindingMetadata } from "networking/reportsApi";

export const dgDiligenceFlagKey = "_dgDiligence";
export const dgDiligenceFlagValue = "Flagged";

export function hasDiligenceFlag(metadata?: BindingMetadata) {
    return metadata?.[dgDiligenceFlagKey] === dgDiligenceFlagValue;
}
